import type { FormType } from '@aloft/toolkit-shared';
import type { useModal } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { ExportModalContent } from './ExportModalContent.tsx';
import type { ClickFormsExisting, ExportType } from './types.ts';
import { useHandleExportClick } from './useHandleExportClick.ts';
import { exportIsDisabled } from './utils/exportIsDisabled.ts';

export const ExportModalInternal = ({
  Modal,
  closeModal,
  isModalOpen,
  exportType,
  setExportType,
  clickFormsExisting,
  setClickFormsExisting,
  formType,
  setFormType,
}: {
  Modal: ReturnType<typeof useModal>['Modal'];
  closeModal: ReturnType<typeof useModal>['closeModal'];
  isModalOpen: ReturnType<typeof useModal>['isModalOpen'];
  exportType?: ExportType;
  setExportType: (val?: ExportType) => void;
  clickFormsExisting?: ClickFormsExisting;
  setClickFormsExisting: (val?: ClickFormsExisting) => void;
  formType: FormType;
  setFormType: (val: FormType) => void;
}) => {
  const [includeAnnotations, setIncludeAnnotations] = useState<boolean>(false);
  const [exportClicked, setExportClicked] = useState<boolean>(false);

  const handleExportClick = useHandleExportClick();

  const handleClose = () => {
    // reset everything
    setExportType(undefined);
    setClickFormsExisting(undefined);
    setFormType(formType);
    setIncludeAnnotations(false);
    closeModal();
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleClose}
      primaryAction={{
        text: 'Export',
        disabled: exportIsDisabled(exportType, clickFormsExisting, formType, exportClicked),
        onClick: () =>
          handleExportClick(
            exportType,
            formType,
            clickFormsExisting,
            setExportClicked,
            includeAnnotations,
          ),
      }}
      secondaryAction={{ text: 'Cancel', onClick: handleClose }}
    >
      <ExportModalContent
        exportType={exportType}
        setExportType={setExportType}
        clickFormsExisting={clickFormsExisting}
        setClickFormsExisting={setClickFormsExisting}
        formType={formType}
        setFormType={setFormType}
        includeAnnotations={includeAnnotations}
        setIncludeAnnotations={setIncludeAnnotations}
      />
    </Modal>
  );
};
